<div class="section-container">
  <div class="row">
    <div class="heading-text"><!-- {{ "quoteCheckout.guestCheckoutSold" | cxTranslate }} --></div>
  </div>
  <hr />
  <div class="row">
    <div class="section-heading-text"><!-- {{ "quoteCheckout.guestCheckoutSold2" | cxTranslate }} --></div>
  </div>

  <vs-sold-to-address
    [isSubmitted]="isSubmitted"
    [count]="count"
    [validationGroup]="validationGroup"
    [billToAddress]="cartData?.billToAddress"
    (billToAddressUpdate)="billToAddressUpdate($event)"
  >
  </vs-sold-to-address>
</div>
<div class="section-container">
  <div class="row">
    <div class="heading-text mt-43">{{ "quoteCheckout.guestCheckoutShip" | cxTranslate }}</div>
  </div>
  <hr />
  <div class="row">
    <div class="section-heading-text">{{ "quoteCheckout.guestCheckoutShip2" | cxTranslate }}</div>
  </div>
  <vs-ship-to-address
    [isSubmitted]="isSubmitted"
    [validationGroup]="validationGroup"
    [deliveryAddress]="cartData?.deliveryAddress"
    [billToAddress]="cartData?.billToAddress"
    [count]="count"
    (deliveryAddressUpdate)="deliveryAddressUpdate($event)"
    (getSoldToAddress)="getSoldToAddress($event)"
  ></vs-ship-to-address>
</div>

<div class="section-container">
  <div class="row">
    <div class="heading-text mt-43">{{ "quoteCheckout.guestCheckoutDetail" | cxTranslate }}</div>
  </div>
  <hr />
  <div class="row">
    <div class="section-heading-text">{{ "quoteCheckout.endCustomerAddress" | cxTranslate }}</div>
  </div>
  <vs-end-customer-address
    [isSubmitted]="isSubmitted"
    [orderType]="orderType"
    [deliveryAddress]="cartData?.deliveryAddress"
    [endUserAddress]="cartData?.endUserAddress"
    [rfqTypes]="rfqTypes"
    [count]="count"
    [validationGroup]="validationGroup"
    (endCountryData)="endCountryData($event)"
    (endCustomerAddressUpdate)="endCustomerAddressUpdate($event)"
    [legalEntity]="cartData?.legalEntity"
    [endUserIndustryName]="cartData?.endUserIndustry"
    (endUserIndustryUpdate)="endUserIndustryUpdate($event)"
    (legalEntityChange)="legalEntityChange($event)"
  ></vs-end-customer-address>
</div>
<div class="section-container">
  <div class="row">
    <div class="heading-text mt-43">
      <span class="require">* </span>{{ "quoteCheckout.guestCheckoutQuestionnaire" | cxTranslate }}
    </div>
  </div>
  <hr />
  <vs-compliance-questions
    [isSubmitted]="isSubmitted"
    [complienceQuestions]="complienceQuestions"
    [loggedIn]="loggedIn"
    [warningFlagText]="warningFlagText"
    (warningFlagTextUpdate)="warningFlagTextUpdate($event)"
    (complienceQuestionsUpdates)="complienceQuestionsUpdates($event)"
  ></vs-compliance-questions>
</div>

<div class="section-container">
  <div class="row">
    <div class="heading-text mt-43">{{ "quoteCheckout.guestCheckoutNotifications" | cxTranslate }}</div>
  </div>
  <hr />
  <div [formGroup]="notificationsForm">
    <div class="row">
      <div class="col-3">
        <div class="vs-text-field">
          <label
            ><span class="require">* </span>{{ "quoteCheckout.guestCheckoutEmail" | cxTranslate }}</label
          >
          <input
            type="text"
            formControlName="quoteAcknowldge"
            placeholder='{{ "quoteCheckout.guestCheckoutEmail" | cxTranslate }}'
            (input)="changeQuoteAcknowledgement()"
            [ngClass]="
              (quoteAcknowldge.invalid &&
                (quoteAcknowldge.dirty || quoteAcknowldge.touched) &&
                !quoteAcknowldge.valid) ||
              (!notificationsForm.valid &&
                isSubmitted &&
                !quoteAcknowldge.valid)
                ? 'error'
                : ''
            "
          />
          <label
            class="tag-section-custom-label-width custom-label error"
            *ngIf="
              (quoteAcknowldge.invalid &&
                (quoteAcknowldge.dirty || quoteAcknowldge.touched) &&
                !quoteAcknowldge.valid) ||
              (!notificationsForm.valid &&
                isSubmitted &&
                !quoteAcknowldge.valid)
            "
          >
            {{ "quoteCheckout.guestCheckoutEmail2" | cxTranslate }}
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-22">
      <div class="col-3">
        <div class="vs-text-field">
          <label><span class="require">* </span>{{ "quoteCheckout.guestCheckoutContact" | cxTranslate }}</label>
          <input
            type="text"
            (keypress)="acceptNumberOnly($event)"
            formControlName="contactNumber"
            placeholder='{{ "quoteCheckout.guestCheckoutContact" | cxTranslate }}'
            (input)="changeContactNumber()"
            [ngClass]="
              (contactNumber.invalid &&
                (contactNumber.dirty || contactNumber.touched) &&
                !contactNumber.valid) ||
              (!notificationsForm.valid && isSubmitted && !contactNumber.valid)
                ? 'error'
                : ''
            "
          />
          <label
            class="tag-section-custom-label-width custom-label error"
            *ngIf="
              (contactNumber.invalid &&
                (contactNumber.dirty || contactNumber.touched) &&
                !contactNumber.valid) ||
              (!notificationsForm.valid && isSubmitted && !contactNumber.valid)
            "
          >
            {{ "quoteCheckout.guestCheckoutContact2" | cxTranslate }}
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-question">
    <vs-notification-attachments
      (updateFiles)="updateFiles($event)"
      [attachments]="cartData?.attachments"
    ></vs-notification-attachments>
  </div>
</div>
